// Pure helpers for the weekly time-entry grid. No React, no I/O — unit tested.

// Parse "YYYY-MM-DD" as a *local* date (avoid UTC off-by-one from new Date(str)).
function parseISO(str) {
  const [y, m, d] = str.split("-").map(Number);
  return new Date(y, m - 1, d);
}

function toISO(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// Monday of the week containing `dateStr` (ISO week, Monday start).
export function mondayOf(dateStr) {
  const d = parseISO(dateStr);
  const dow = (d.getDay() + 6) % 7; // 0 = Monday ... 6 = Sunday
  d.setDate(d.getDate() - dow);
  return toISO(d);
}

// 7 ISO date strings Monday..Sunday starting at weekStart (a Monday ISO string).
export function weekDays(weekStart) {
  const start = parseISO(weekStart);
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    return toISO(d);
  });
}

// Map of dayISO -> entries[] for the given days (empty arrays for empty days).
export function groupByDay(entries, days) {
  const out = {};
  days.forEach((d) => (out[d] = []));
  entries.forEach((e) => {
    if (out[e.date]) out[e.date].push(e);
  });
  return out;
}

export function isEntryComplete(e) {
  return Boolean(e.client && e.time_code && Number(e.hours) > 0);
}

// Ids of entries that are not complete enough to submit.
export function validateWeek(entries) {
  return entries.filter((e) => !isEntryComplete(e)).map((e) => e.id);
}

// Every Monday (ISO string) for the weeks that overlap [startISO, endISO].
export function weekStartsBetween(startISO, endISO) {
  const out = [];
  let cur = parseISO(mondayOf(startISO));
  const end = parseISO(endISO);
  while (cur <= end) {
    out.push(toISO(cur));
    cur = new Date(cur);
    cur.setDate(cur.getDate() + 7);
  }
  return out;
}

export const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
